export default __webpack_public_path__ + "static/media/bilal.0fa04b3b.png";